import { render, staticRenderFns } from "./CashiersLimitsSidebarUser.vue?vue&type=template&id=03940e04"
import script from "./CashiersLimitsSidebarUser.vue?vue&type=script&lang=js"
export * from "./CashiersLimitsSidebarUser.vue?vue&type=script&lang=js"
import style0 from "./CashiersLimitsSidebarUser.vue?vue&type=style&index=0&id=03940e04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports